import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import animate from "animate.css"
import './styles/banners.css'
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth'
import axios from 'axios'
// Import d’AOS et du fichier CSS associé
import AOS from 'aos';
import 'aos/dist/aos.css';
import installerRepliClicKonva from './konva-clic-repli'


// Avant tout rendu : certains bloqueurs de publicité rendent les points des expositions
// insensibles au clic. Voir konva-clic-repli.js.
installerRepliClicKonva()

const firebaseConfig = {
    apiKey: "AIzaSyDKpp8I1dpyp8qZfp27W_JNvAW8gtyNfKY",
    authDomain: "at-expo.firebaseapp.com",
    projectId: "at-expo",
    storageBucket: "at-expo.appspot.com",
    messagingSenderId: "235040013651",
    appId: "1:235040013651:web:12ac96c8cfae55af9635a6"
  };

  const firebaseApp = initializeApp(firebaseConfig);


createApp(App).use(Quasar, quasarUserOptions, animate).use(store).use(router).use(AOS).mount('#app')
const auth = getAuth()

// Jeton Firebase sur chaque appel vers NOTRE API (et elle seule) : l'API refuse les écritures anonymes.
// getIdToken() est mis en cache et rafraîchi par le SDK Firebase, l'appel est bon marché.
// Comparaison d'origine, pas de préfixe : un hôte « apiexpo.alpatechnologies.cloud.autre.com » ne doit jamais recevoir le jeton.
const apiOrigin = (() => {
  try { return new URL((process.env.VUE_APP_BASEURL || '').trim()).origin }
  catch (e) { console.warn('[api] VUE_APP_BASEURL invalide, aucun jeton ne sera envoyé :', e.message); return null }
})()
axios.interceptors.request.use(async (config) => {
  if (!apiOrigin || !auth.currentUser) return config
  let target
  try { target = new URL(config.url || '', config.baseURL || window.location.href) }
  catch (e) { console.warn('[api] URL de requête invalide, appel envoyé sans jeton :', config.url); return config }
  if (target.origin === apiOrigin) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${await auth.currentUser.getIdToken()}`
  }
  return config
})

export { auth, firebaseApp }
